<template>
  <v-app id="app">
    <v-row class="app-holder">
      <v-col cols="12">
        <router-view :key="$route.fullPath"></router-view>
      </v-col>
    </v-row>
  </v-app>
</template>

<script>
export default {
  name: "App",

  components: {},

  data: () => ({
    //
  }),
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  overflow-x: hidden;
  height: 100%;
}
html,
body {
  height: 100%;
}

.app-holder {
  height: 100%;
}
</style>
